<template>
  <div class="commodity">
    <div class="contentRight2">
      <div class="contentTabs">
        <!-- 顶部tab栏 -->
        <el-tabs v-model="activeName" style="height: 100%;" @tab-click="flTab">
          <el-tab-pane label="商品管理" style="height: 100%;" name="first">
            <div v-if="!isAdd" style="height: 100%">
              <div v-if="!isSort" class="commodityHead row">
                <el-button class="button" type="primary" @click="add()">新建商品</el-button>
                <!-- <el-button class="button" type="primary" @click="changeCommidityPageNo()">改</el-button> -->

                <el-button
                  class="button2"
                  :disabled="indexNumber == 0"
                  @click="Sort(1)"
                  style=" margin-left: 10px;"
                >商品排序</el-button>

                <el-upload
                  style="margin-left:10px;"
                  class="upload-demo"
                  action="https://api.yichengshi.cn/qrcapi/Goods_importGoodsNum"
                  :http-request="handleAvatarSuccess2"
                  :show-file-list="false"
                  multiple
                >
                  <el-button class="loadup" type="primary">批量上传商品</el-button>
                </el-upload>

                <div style="margin-left:10px;margin-top:8px;font-size:12px;cursor:pointer">
                  <img src="../../assets/icon/xz.png" alt />
                  <span style="color:#409eff;">
                    <a :href="url+'/download/导入钱如潮商品模板.xls'">下载模板</a>
                  </span>
                </div>
                <div style="margin:0 20px;color:#eee;font-size: 22px;">|</div>
                <el-button @click="ischeck" class="button">
                  <div class="center">
                    <img v-if="buttonState == 1" src="../../assets/icon/wx.png" alt />   <!--未选中-->
                    <img v-if="buttonState == 3" src="../../assets/icon/qx.png" alt />   <!--全选中-->
                    <img v-if="buttonState == 2 " src="../../assets/icon/wqx.png" alt /> <!--未全选中-->
                    <span style="margin-left:5px;">全选</span>
                  </div>
                </el-button>
                <el-button class="button" :disabled="buttonState == 1" @click="allPutAway">上架</el-button>
                <el-button class="button" :disabled="buttonState == 1" @click="allSoldOut">下架</el-button>
                <el-popover
                  :value="isValue"
                  ref="cateRadio2"
                  id="display"
                  placement="bottom"
                  width="150"
                  trigger="click"
                >
                  <div v-for="(item2,index2) in tableData" :key="index2">
                    <div v-if="item2.categoryName!=='全部'" class="classfiyPop">
                      <el-radio
                        :label="item2.categoryName"
                        @change="allCateClick(item2)"
                        v-model="radio"
                        class="marginRight10"
                      ></el-radio>
                      <!-- {{item2.categoryName}} -->
                    </div>
                  </div>
                  <div class="br"></div>
                  <div class="center">
                    <el-button
                      class="button button3"
                      @click="allCateChange()"
                      type="primary"
                      :disabled="radio==''"
                    >保存</el-button>
                    <el-button class="button button3" @click="cateOut2()">取消</el-button>
                  </div>

                  <el-button class="button" slot="reference" :disabled="buttonState == 1">改分类</el-button>
                </el-popover>

                <!-- <el-button class="button" :disabled="buttonState == 1" @click="allRemove">删除</el-button> -->
                <el-button
                  class="button"
                  :disabled="buttonState == 1"
                  @click="dialogVisible = true"
                >删除</el-button>

                <el-select v-model="expireTimeId" placeholder="请选择是否已经过期商品" style="margin-left:15px;" @change="onChange_expireTime">
                  <el-option
                    v-for="item in expireTimeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>

                <div class="row" style="position: absolute;right:230px;">
                  <!-- <el-select style="height:30px;width:110px;" v-model="value" placeholder="全部">
                    <el-option
                      v-for="item in tableData"
                      :key="item.categoryName"
                      :label="item.categoryName"
                      :value="item.goodsCategoryId"
                    ></el-option>
                  </el-select> -->
                  <el-input
                    style="width:170px;margin-left:10px"
                    v-model="value2"
                    placeholder="搜索商品.."
                    @keyup.enter.native="searchEnter(value2)"
                    @blur="searchContentBlur"
                  ></el-input>
                </div>
              </div>

              <!-- 打开商品排序 -->
              <div v-if="isSort" class="commodityHead2 row alignCenter">
                <div style="margin-left:0px;font-size:13px">鼠标拖拽进行排序</div>
                <el-button
                  class="button"
                  type="primary"
                  style="margin-left:20px;"
                  :plain="true"
                  @click="allSort"
                >保存排序</el-button>
                <el-button class="button2" style="width:45px;margin-left:10px;" @click="Sort(0)">取消</el-button>
                <!-- <div style="margin-left:20px;font-size:13px">鼠标拖拽进行排序</div> -->
              </div>

              <!-- 左侧tab栏 -->
              <div v-if="!isSort" id="topTabs" class="leftTabs row">
                <div class="nav">
                  <div
                    @click="navIndex(index)"
                    :class="indexNumber!== index? 'navBlock' : 'navBlock_click'"
                    v-for="(item,index) in this.tableData"
                    :key="index"
                  >{{item.categoryName}}</div>
                </div>
                <div class="navContent">
                  <!-- 商品列表 -->
                  <div v-if="commidityList.length!== 0" class="commidity">
                    <div
                      class="commidityItem row alignCenter"
                      v-for="(item,index) in commidityList"
                      :key="index"
                    >
                      <!-- //商品 -->
                      <el-checkbox
                        @change="commidityClick(item)"
                        v-model="item.click"
                        name="commidityClick"
                      ></el-checkbox>
                      <div v-if="item.saleStatus == 0" class="commidityItemImg">
                        <img :src="item.goodsImage" alt />
                      </div>
                      <div v-if="item.saleStatus == 1" class="commidityItemImg2">
                        <div v-if="item.goodsImage"><img :src="item.goodsImage" alt /></div>
                        <div v-if="!item.goodsImage"><img src="../../assets/icon/defaultPic.png" alt /></div>
                      </div>
                      <div style="margin-left:10px;">
                        <div v-if="item.saleStatus == 1" class="goodName">{{item.goodsName}}</div>
                        <div
                          v-if="item.saleStatus == 0"
                          class="goodName"
                          style="color:#b2b2b2"
                        >{{item.goodsName}}</div>
                        <div class="row" style="margin-top:10px;">
                          <div class="red">￥{{item.retailPrice}} <span v-if="item.hasProduct == 1">起</span></div>
                          <div class="member-price" v-if="item.memberPrice">会员价：￥{{item.memberPrice}} <span v-if="item.hasProduct == 1">起</span></div>
                          <div v-if="!item.isInfiniteStock" class="num">库存：{{item.qrcTotalStockCount}}</div>
                          <div v-if="item.isInfiniteStock" class="num">库存：无限库存</div>
                        </div>
                      </div>
                      <!-- 按钮组 -->
                      <div style="position: absolute;right:20px;">
                        <el-button
                          v-if="item.saleStatus == 1"
                          class="button2"
                          @click="allSoldOut2(item)"
                        >下架</el-button>
                        <el-button
                          v-if="item.saleStatus == 0"
                          class="button"
                          @click="allPutAway2(item)"
                        >上架</el-button>
                        <el-button class="button2" @click="add(item)">编辑</el-button>
                        <!-- 改分类弹出层 -->
                        <el-popover
                          :value="isValue"
                          ref="cateRadio"
                          id="display"
                          placement="bottom"
                          width="150"
                          trigger="click"
                        >
                          <div v-for="(item2,index2) in tableData" :key="index2">
                            <div v-if="item2.categoryName!=='全部'" class="classfiyPop">
                              <el-radio
                                :label="item2.categoryName"
                                @change="cateClick(item,item2)"
                                v-model="radio"
                                class="marginRight10"
                              ></el-radio>
                              <!-- {{item2.categoryName}} -->
                            </div>
                          </div>
                          <div class="br"></div>
                          <div class="center">
                            <el-button
                              class="button button3"
                              @click="cateChange(index)"
                              type="primary"
                              :disabled="radio==''"
                            >保存</el-button>
                            <el-button class="button button3" @click="cateOut(index)">取消</el-button>
                          </div>

                          <el-button class="button" slot="reference" @click="handleReset(item)">改分类</el-button>
                        </el-popover>
                        <el-button
                          class="button"
                          @click="dialogVisible2 = true,delGoodsId = item.id"
                        >删除</el-button>
                      </div>
                    </div>
                    <!-- 分页 -->
                    <div class="block" style="float:right;margin-top:10px;">
                      <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pageNum"
                        :page-size="10"
                        layout="total, prev, pager, next, jumper"
                        :total="totalCount"
                      ></el-pagination>
                    </div>
                  </div>
                  <div v-if="commidityList == 0" class="commidity" style="padding:20px 20px">暂无商品</div>
                </div>
              </div>
              <div v-if="isSort" class="commidity2">
                <!-- 拖拽排序 -->
                <draggable
                  v-model="commidityList"
                  group="people"
                  @start="drag=true"
                  @end="drag=false"
                >
                  <div
                    class="commidityItem row alignCenter"
                    v-for="(item,index) in commidityList"
                    :key="index"
                  >
                    <!-- //商品 -->
                    <!-- <img :src="item.goodsImage" alt style="height:50px;width:50px;" /> -->
                    <div v-if="item.saleStatus == 0" class="commidityItemImg">
                        <img :src="item.goodsImage" alt />
                      </div>
                      <div v-if="item.saleStatus == 1" class="commidityItemImg2">
                        <div v-if="item.goodsImage"><img :src="item.goodsImage" alt /></div>
                        <div v-if="!item.goodsImage"><img src="../../assets/icon/defaultPic.png" alt /></div>
                      </div>
                    <div style="margin-left:10px;">
                      <div>{{item.goodsName}}</div>
                      <div class="row" style="margin-top:10px;">
                        <div class="red">￥{{item.retailPrice}}</div>
                        <div class="num">库存：{{item.qrcTotalStockCount}}</div>
                      </div>
                    </div>
                    <!-- 按钮组 -->
                    <div style="position: absolute;right:20px;">
                      <el-button class="button2" @click="moveGoods(item)">移到顶部</el-button>
                      <el-button
                        class="button2"
                        @click="dialogVisible2 = true,delGoodsId = item.id"
                      >删除</el-button>
                    </div>
                  </div>
                </draggable>
              </div>
            </div>

            <!-- 新建商品 -->
            <div v-if="isAdd" style="box-sizing: border-box;">
              <div class="commodityHead" style="padding-bottom:0;height:40px;">
                <el-breadcrumb class="elArrowText" separator-class="el-icon-arrow-right">
                  <el-breadcrumb-item>
                    <a @click="add()" href="javascript:;">商品管理</a>
                  </el-breadcrumb-item>
                  <el-breadcrumb-item v-if="isAddGoods">新建商品</el-breadcrumb-item>
                  <el-breadcrumb-item v-if="!isAddGoods">编辑商品</el-breadcrumb-item>
                </el-breadcrumb>
              </div>
              <!-- 表单验证 -->
              <div class="from" style="margin-top:20px;">
                <el-form
                  :model="ruleForm"
                  ref="ruleForm"
                  :rules="rules"
                  class="demo-ruleForm"
                  label-width="150px"
                  label-position="right"
                  hide-required-asterisk
                >
                  <!-- <el-form-item label="商品上架到易城市：" prop="saleStatus">
                    <el-switch v-model="ruleForm.saleStatus"></el-switch>
                  </el-form-item>-->
                  <el-form-item label="商品照片：">
                    <div>
                      <el-upload
                        class="avatar-uploader"
                        action="${ImgUrl}/ImageServer/YmUpload_image"
                        list-type="picture-card"
                        :http-request="editHandleAvatarSuccess2"
                        :show-file-list="false"
                      >
                        <img v-if="imageUrl" :src="imageUrl" class="avatar" />
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload>
                      <!-- <div class="text2">图片大小不得超过3M，建议使用方形图片</div> -->
                    </div>
                  </el-form-item>

                  <el-form-item label="商品名称：" prop="goodsName">
                    <el-input
                      autofocus="true"
                      style="width:480px"
                      placeholder="输入商品名称"
                      v-model="ruleForm.goodsName"
                      maxlength="10"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="商品描述：">
                    <el-input
                      style="width:480px;"
                      placeholder="输入商品描述"
                      type="textarea"
                      v-model="ruleForm.goodsDescription"
                    ></el-input>
                  </el-form-item>
                  <!-- <el-form-item label="商品条码：">
                    <el-input
                      style="width:200px"
                      placeholder="输入商品条码"
                      v-model="ruleForm.goodsBarCode"
                    ></el-input>
                  </el-form-item>-->
                  <el-form-item label="商品分类：" prop="goodsCategoryId">
                    <el-select
                      style="width:200px"
                      v-model="ruleForm.goodsCategoryId"
                      placeholder="选择商品分类"
                    >
                      <el-option
                        v-for="item in tableData"
                        :key="item.value"
                        :label="item.categoryName"
                        :value="item.goodsCategoryId"
                        v-show="item.categoryName !=='全部'"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label=" 商品规格：">
                    <!-- <el-button size="small" @click="Show">商品规格</el-button> -->
                    <!-- 商品规格表格 -->
                    <div id="spgg" class="commodityHead3">
                      <el-table :data="tableData2">
                        <el-table-column label="商品规格" width="135">
                          <template slot-scope="scope">
                            <el-input placeholder="填写商品规格" v-model="scope.row.specificationName"></el-input>
                          </template>
                        </el-table-column>
                        <el-table-column label="零售价（元）" width="110">
                          <template slot-scope="scope">
                            <el-input
                              placeholder="售价"
                              type="number"
                              clearable
                              :data-index="scope.row.barCode"
                              @blur="retailPriceBlur"
                              v-model="scope.row.retailPrice"
                            ></el-input>
                          </template>
                        </el-table-column>
                        <el-table-column label="原价（元）" width="110">
                          <template slot-scope="scope">
                            <el-input
                              placeholder="原价"
                              type="number"
                              clearable
                              :data-index="scope.row.barCode"
                              @blur="costPriceBlur"
                              v-model="scope.row.costPrice"
                            ></el-input>
                          </template>
                        </el-table-column>
                        <el-table-column label="会员价（元）" width="110">
                          <template slot-scope="scope">
                            <el-input
                              placeholder="会员价"
                              type="number"
                              clearable
                              :data-index="scope.row.barCode"
                              @blur="memberPriceBlur"
                              v-model="scope.row.memberPrice"
                            ></el-input>
                          </template>
                        </el-table-column>
                        <el-table-column label="进货价（元）" width="110">
                          <template slot-scope="scope">
                            <el-input
                              placeholder="进货价"
                              type="number"
                              clearable
                              :data-index="scope.row.barCode"
                              @blur="takePriceBlur"
                              v-model="scope.row.takePrice"
                            ></el-input>
                          </template>
                        </el-table-column>
                        <el-table-column label="商品单位" width="120">
                          <template slot-scope="scope">
                            <el-select
                              style="height:30px;width:110px;"
                              v-model="scope.row.goodsUnitId"
                              placeholder="单位"
                            >
                              <el-option
                                v-for="item in unitList"
                                :key="item.goodsUnitId"
                                :label="item.goodsUnit"
                                :value="item.goodsUnitId"
                              ></el-option>
                            </el-select>
                          </template>
                        </el-table-column>
                        <el-table-column label="商品条码" width="150">
                          <template slot-scope="scope">
                            <el-input placeholder="填写商品条码" v-model="scope.row.barCode"></el-input>
                          </template>
                        </el-table-column>
                        <el-table-column label="商品过期时间" width="230">
                          <template slot-scope="scope">
                            <el-date-picker
                              @change="expireTime_change"
                              v-model="scope.row.expireTime"
                              type="date"
                              value-format="yyyy-MM-dd"
                              placeholder="选择过期时间">
                            </el-date-picker>
                          </template>
                        </el-table-column>
                        <el-table-column label="库存" width="370">
                          <template slot-scope="scope">
                            <el-radio v-model="scope.row.isInfiniteStock" label="无限库存" checked></el-radio>
                            <el-radio v-model="scope.row.isInfiniteStock" label="自定义库存"></el-radio>
                            <el-input
                              v-if="scope.row.isInfiniteStock == '自定义库存' && scope.row.unitType == 2"
                              placeholder="库存"
                              style="width:90px;"
                              type="number"
                              :data-index="scope.row.barCode"
                              @blur="qrcStockCountBlur"
                              v-model.number="scope.row.qrcStockCount"
                            ></el-input>
                            <el-input
                              v-if="scope.row.isInfiniteStock == '自定义库存' && scope.row.unitType == 1"
                              placeholder="库存"
                              style="width:90px;"
                              :data-index="scope.row.barCode"
                              @blur="qrcStockCountBlur"
                              v-model.number="scope.row.qrcStockCount"
                            ></el-input>
                            <el-input
                              v-if="scope.row.isInfiniteStock == '自定义库存' && scope.row.unitType !== 1 && scope.row.unitType !== 2"
                              placeholder="库存"
                              style="width:90px;"
                              type="number"
                              :data-index="scope.row.barCode"
                              @blur="qrcStockCountBlur"
                              v-model.number="scope.row.qrcStockCount"
                            ></el-input>
                            <el-button
                              style="color:#FE4F4D;margin-left:25px;"
                              size="mini"
                              type="text"
                              @click="handleDelete(scope.$index, scope.row)"
                            >删除</el-button>
                          </template>
                        </el-table-column>
                      </el-table>
                      <div class="row"> 
                      <el-button
                        style="width:115px;height:30px;margin-top:15px;margin-left:10px;line-height:5px;"
                        class="justCenter"
                        @click="handPush"
                      >添加商品规格</el-button>
                      <el-button
                        style="height:30px;margin-top:15px;margin-left:10px;line-height:5px;"
                        class="justCenter"
                        type="primary"
                        @click="jumpTT('unitManagement')"
                      >单位管理</el-button>
                      </div>
                    </div>
                  </el-form-item>
                  <!-- <el-form-item label="商品售价：" prop="retailPrice">
                    <el-input
                      type="number"
                      style="width:200px"
                      clearable
                      placeholder="输入商品售价"
                      v-model.number="ruleForm.retailPrice"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="商品原价：" prop="costPrice">
                    <el-input
                     type="number"
                      style="width:200px"
                      placeholder="输入商品原价"
                      clearable
                      v-model.number="ruleForm.costPrice"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="商品库存：" prop="totalStockCount">
                    <el-radio-group v-model="ruleForm.isInfiniteStock">
                      <el-radio @change="isinputShow('无限库存')" label="无限库存" value="1"></el-radio>
                      <el-radio @change="isinputShow('自定义库存')" label="自定义库存" value="2"></el-radio>
                      <el-input
                        v-if="inputShow == '自定义库存'"
                        v-model.number="ruleForm.totalStockCount"
                        style="height:30px;width:70px;"
                      ></el-input>
                    </el-radio-group>
                  </el-form-item>-->
                  <el-form-item label="信息备注：">
                    <el-input
                      style="width:480px;"
                      placeholder="输入备注信息"
                      type="textarea"
                      v-model="ruleForm.goodsRemark"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button size="small" type="primary" @click="submitForm()">确定</el-button>
                    <!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
                  </el-form-item>
                </el-form>
              </div>
            </div>
          </el-tab-pane>

          <!-- 分类管理标签页面 -->
          <el-tab-pane id="fenye" style="height: 100%;" label="分类管理" name="second">
            <div v-if="!isSort2" class="commodityHead row alignCenter">
              <el-button class="button" type="primary" @click="dialogVisible4 = true">新建分类</el-button>
              <el-button class="button2" style="margin-left: 10px;" @click="Sort2">分类排序</el-button>
              <el-upload
                style="margin-left:10px;"
                class="upload-demo"
                action="https://api.yichengshi.cn/qrcapi/Goods_importGoodsNum"
                :http-request="handleAvatarSuccess3"
                :show-file-list="false"
                multiple
              >
                <el-button class="loadup" type="primary">批量上传商品分类</el-button>
              </el-upload>
              <div style="margin-left:10px;margin-top:8px;font-size:12px;cursor:pointer">
                <img src="../../assets/icon/xz.png" alt />
                <span style="color:#409eff;">
                  <a :href="url+'/download/导入商品分类模板.xls'">下载模板</a>
                </span>
              </div>
            </div>
            <!-- 打开分类排序 -->
            <div v-if="isSort2" class="commodityHead2 row alignCenter">
              <div style="margin-left:0px;font-size:13px">点击置顶按钮进行排序</div>
              <!-- <el-button class="button" type="primary" :plain="true" @click="open2">保存排序</el-button> -->
              <el-button class="button2" style="width:45px;margin-left:10px;" @click="Sort2">取消</el-button>
              <!-- <div style="margin-left:20px;font-size:13px">鼠标拖拽进行排序</div> -->
            </div>
            <div style="padding: 30px;margin-top: 60px;">
              <!-- 表格 -->
              <el-table :data="tableData" style="width: 100%">
                <el-table-column align="left" prop="categoryName" label="分类" width="180"></el-table-column>
                <el-table-column align="center" prop="goodsTypes" label="包含商品" width="180"></el-table-column>
                <el-table-column align="center" prop="otherNumber" label="分类编号" width="180"></el-table-column>
                <el-table-column label="操作" class-name="tableHead" align="right">
                  <template slot-scope="scope">
                    <el-button
                      v-if="scope.$index!==0 && !isSort2"
                      size="mini"
                      type="primary"
                      @click="handleEditId =  scope.row.goodsCategoryId,dialogVisible5 = true,categoryEdit.value = scope.row.categoryName,categoryEdit.otherNumber = scope.row.otherNumber"
                    >编辑</el-button>
                    <el-button
                      v-if="scope.$index!==0 && !isSort2"
                      size="mini"
                      @click="dialogVisible3 = true,delFenleiId = scope.row.goodsCategoryId"
                    >删除</el-button>
                    <el-button
                      size="mini"
                      v-if="scope.$index!==0 && isSort2"
                      class="button2"
                      style="margin-left: 10px;"
                      @click="moveClassify(scope.row)"
                    >移到顶部</el-button>
                    <el-button
                      size="mini"
                      v-if="scope.$index!==0 && isSort2"
                      class="button2"
                      style="margin-left: 10px;"
                      @click="dialogVisible3 = true,delFenleiId = scope.row.goodsCategoryId"
                    >删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div class="block" v-if="totalCount2" style="float:right;margin-top:10px;">
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange2"
                  :current-page.sync="pageNos"
                  :page-size="10"
                  layout="total, prev, pager, next, jumper"
                  :total="totalCount2"
                ></el-pagination>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane style="height: 100%;" label="单位管理" name="third"></el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
      <span>是否删除该商品，删除后数据消失，无法恢复！！</span>
      <span slot="footer" class="dialog-footer" style="z-index:2100">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="allRemove">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="dialogVisible2" width="30%">
      <span>是否删除该商品，删除后数据消失，无法恢复！！</span>
      <span slot="footer" class="dialog-footer" style="z-index:2100">
        <el-button @click="dialogVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="removeGoods()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="dialogVisible3" width="30%">
      <span>是否删除该分类，删除后数据消失，无法恢复！！</span>
      <span slot="footer" class="dialog-footer" style="z-index:2100">
        <el-button @click="dialogVisible3 = false">取 消</el-button>
        <el-button type="primary" @click="handleDelete2()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="新建分类" :visible.sync="dialogVisible4" width="30%">
      <span>分类名：</span>
      <el-input style="margin:20px 0" v-model="category.value" placeholder="分类名"></el-input>
      <div>
        <span>分类编号：</span>
        <el-input style="margin:20px 0" v-model="category.otherNumber" placeholder="分类编号" @blur="otherNumberBlur"></el-input>
      </div>
      <span slot="footer" class="dialog-footer" style="z-index:2100">
        <el-button @click="dialogVisible4 = false">取 消</el-button>
        <el-button type="primary" @click="open()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="编辑分类" :visible.sync="dialogVisible5" width="30%">
      <span>分类名：</span>
      <el-input style="margin:20px 0" v-model="categoryEdit.value" placeholder="分类名"></el-input>
      <div>
        <span>分类编号：</span>
        <el-input style="margin:20px 0" v-model="categoryEdit.otherNumber" placeholder="分类编号" onkeyup="this.value=this.value.replace(/\D/g,'')"></el-input>
      </div>
      <span slot="footer" class="dialog-footer" style="z-index:2100">
        <el-button @click="dialogVisible5 = false">取 消</el-button>
        <el-button type="primary" @click="handleEdit()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible6" :close-on-click-modal="false" width="40%">
      <div>
        <img src="../../assets/icon/success.png" style="width:30px;height:30px;vertical-align:middle;margin-right:5px;"/>
        <span>已经成功上传<strong>{{successCount}}</strong>个产品</span>
      </div>
       <div style="margin:10px 0;">
        <img src="../../assets/icon/fault.png" style="width:30px;height:30px;vertical-align:middle;margin-right:5px;"/>
        <span><strong>{{failCount}}</strong>个产品信息错误未成功上传 请下载错误商品表格 更改后重新上传</span>
      </div>
      <el-table :data="errorTableData" border style="width: 100%" :max-height="450">
        <el-table-column prop="goodsName" label="品名" min-width="25%" /> 
        <el-table-column prop="valueContent" label="规格" min-width="25%" />
        <el-table-column prop="goodsBarCode" label="条码" min-width="25%" />
        <el-table-column prop="otherNumber" label="分类编号" min-width="25%" />
      </el-table>
      <div style="margin-top: 10px;">
        请检查核对后重新上传：
        <div>1.品名，规格，单位，零售价，分类编号不能为空</div>
        <div>2.销售价 进货价 和库存是否是数字，金额是否小于0.01  </div>
        <div>3.是否已经导入了商品分类 4.是否已存在相同条形码商品</div>
        <div>5.计件单位库存必须为整数，计重单位库存数是否小于0.01</div>
        <div>注：担，公斤，吨，两，钱，克，斤  为计重单位</div>
      </div>
      <span slot="footer" class="dialog-footer" style="z-index:2100">
        <el-button @click="dialogVisible6 = false">关闭</el-button>
        <el-button type="primary" @click="handleErrorTable()">下载表格</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  uploadExcl,
  goodsCategoryPager,
  goodsUnitList,
  uploadExcl2,
  uploadImg
} from "../api";
import draggable from "vuedraggable";
export default {
  name: "commodity",

  components: {
    draggable
  },

  data() {
    var checkAge = (rule, value, callback) => {
      if (!value && this.ruleForm.isInfiniteStock == "自定义库存") {
        return callback(new Error("库存不能为空"));
      } else if (
        typeof value !== "number" &&
        this.ruleForm.isInfiniteStock == "自定义库存"
      ) {
        return callback(new Error("请输入数字"));
      } else {
        callback();
      }
    };
    return {
      expireTimeList: [
        { value: 99, label: '是否过期' },
        { value: 1, label: '即将过期' },
        { value: 3, label: '3天内过期' },
        { value: 7, label: '7天内过期' },
        { value: 30, label: '一个月内过期' },
        { value: 0, label: '已经过期' }
      ],
      expireTimeId: 99,
      successCount: "",
      failCount: "",
      category: {
        value: "",
        otherNumber: ""
      },
      categoryEdit: {
        value: "",
        otherNumber: ""
      },
      commidityPageNo: 1,
      classifyPage: "", //分类分页当前页
      dialogVisible: false,
      dialogVisible2: false,
      dialogVisible3: false,
      dialogVisible4: false,
      dialogVisible5: false,
      dialogVisible6: false,
      delGoodsId: "",
      isAddGoods: "",
      handleEditId: "",

      totalCount2: "", //分类的页数
      isValue: false,
      cateArr: "",
      cateArr2: "",
      myArray: [{ name: "1" }, { name: "2" }],
      activeName: "first", //标签栏首选
      value: "", //右上下拉框
      // visible: false, //改分类按钮默认状态
      isSort: false, //商品排序
      isSort2: false, //分类排序
      isAdd: false, //新建商品
      isShow: false,
      inputShow: false,
      //表单验证
      ruleForm: {
        saleStatus: true,
        goodsName: "",
        goodsDescription: "",
        goodsCategoryId: "",
        products: [],
        retailPrice: "",
        costPrice: "",
        memberPrice: "",
        isInfiniteStock: "无限库存",
        qrcTotalStockCount: "",
        goodsRemark: "",
        expireTime: ""
      },
      //表单验证规则
      rules: {
        goodsName: [
          { required: true, message: '请输入商品名称', trigger: 'blur' }
        ],
        goodsDescription: [
          { required: true, message: "请输入商品描述", trigger: "blur" }
        ],
        goodsCategoryId: [
          { required: true, message: "请选择分类", trigger: "change" }
        ],
        retailPrice: [
          { required: true, message: "请输入商品售价", trigger: "blur" },
          { type: "number", message: "请输入数字", trigger: "blur" }
        ],
        costPrice: [
          { required: true, message: "请输入商品原价", trigger: "blur" },
          { type: "number", message: "请输入数字", trigger: "blur" }
        ],
        memberPrice: [
          { required: true, message: "请输入商品会员价", trigger: "blur" },
          { type: "number", message: "请输入数字", trigger: "blur" }
        ],
        qrcTotalStockCount: [{ validator: checkAge, trigger: "blur" }],
        goodsRemark: [
          { required: true, message: "请输入备注信息", trigger: "blur" }
        ]
      },
      commidityList: [],
      //商品分类
      tableData: [],
      //表单验证表格
      tableData2: [
        {
          specificationName: "",
          retailPrice: "",
          costPrice: "",
          memberPrice: "",
          barCode: "",
          isInfiniteStock: "无限库存",
          qrcStockCount: 0,
          goodsUnitId: null,
          takePrice: null
        }
      ],
      //右上角下拉框
      options: [
        {
          value: "选项1",
          label: "黄金糕"
        },
        {
          value: "选项2",
          label: "双皮奶"
        },
        {
          value: "选项3",
          label: "蚵仔煎"
        },
        {
          value: "选项4",
          label: "龙须面"
        },
        {
          value: "选项5",
          label: "北京烤鸭"
        }
      ],
      value2: "", //右上输入框
      imageUrl: require("../../assets/icon/mdzp1.png"), //新建商品照片上传图案
      imageUrl2: "", //新建商品照片上传图案
      buttonState: 1, //全选按钮状态 1（未选中）2（未全选）3（全选）
      userList: "", //用户信息
      indexNumber: 0, //左侧导航栏的索引
      goodsCategoryId: "", //产品分类id
      pageNum: 1,
      shopInformation: "", //商店信息
      trueCommodity: [], //勾选的商品id数组
      radio: "", //分类单选按钮
      // visible:false,//分类弹出框
      editGoodsId: "", //修改商品的id
      unitList: [], //单位列表
      unitTypes: "",
      goodSearch: "",
      pageNos: 1,
      errorTableData: [],
      failGoodsExcelUrl: "",
      qrcStockCount: "",
      select_isExpire: ""
    };
  },

  watch: {
    // commidityList: function() {
    //   console.log(this.commidityList, "数组变化");
    // },
    // goodsCategoryId: function() {
    //   console.log(this.goodsCategoryId, "change");
    // }
  },

  created() {
    var that = this;
    console.log(this.url, "radio", this.$route.query.docId);
    if (this.$route.query.docId) {
      this.isAdd = this.$route.query.docId;
    } else if (this.$route.query.activeNameSecond) {
      this.activeName = "second";
    }
    let userList = JSON.parse(this.getCookie("userList"));
    let shopInformation = JSON.parse(this.getCookie("shopInformation"));
    this.userList = userList;
    this.shopInformation = shopInformation;
    // this.request.post("qrcapi/Shop_createShopWorker",{     sessionId: this.userList.sessionId,
    //       userId: this.userList.id,}).then(res=>{console.log(res,'tt')})
    this.Goods_goodsList(); // //获取商品列表
    //修改商品分类排序
    // this.request
    //   .post("qrcapi/GoodsCategory_modifyGoodsCategoryIndex", {
    //     sessionId: userList.sessionId,
    //     userId: userList.id,
    //     goodsCategoryId: "46",
    //     modifyIndexType: "1",
    //     indexNo: "10000"
    //   })
    //   .then(res => {
    //     console.log(res, "商品排序");
    //   });
    
    console.log(this.$route.query.activeNameSecond, 1111111)
    //获取产品分类列表
    if (this.$route.query.activeNameSecond) {
      console.log(4)
      this.goodsCategoryList(1, 10);
      // var activeNameSecond;
      // if (this.$route.query.activeNameSecond == activeNameSecond) {
      //   console.log(1)
      //   this.goodsCategoryList(1, 10);
      // } else {
      //   console.log(2)
      //   this.goodsCategoryList(1, 999);
      // }
    } else {
      console.log(3)
      this.goodsCategoryList(1, 999);
    }
    
    // this.Goods_importGoodsNum(); //导入商品
  },

  destroyed() {
    localStorage.removeItem("searchContent")
    localStorage.removeItem("pageNo")
  },

  methods: {
    onChange_expireTime(val) {
      this.select_isExpire = val
      if (this.select_isExpire !== 99) {
        this.fun_date(this.select_isExpire)
      } else {
        this.Goods_goodsList(this.goodsCategoryId, "", "", 1, "")
      }
    },
    fun_date(num) { 
      var date1 = new Date();
      //今天时间
      var time1 = date1.getFullYear() + "-" + (date1.getMonth() + 1) + "-" + date1.getDate()
      console.log(time1);
      var date2 = new Date(date1);
       date2.setDate(date1.getDate() + num);
       //num是正数表示之后的时间，num负数表示之前的时间，0表示今天
       var time2 = date2.getFullYear() + "-" + (date2.getMonth() + 1) + "-" + date2.getDate(); 
      console.log(time2);
      this.Goods_goodsList(this.goodsCategoryId, "", "", 1, time2)
      return time2;
    },
    otherNumberBlur(e) {
      let reg = /^[1-9]\d*$/
      console.log(e.target.value)
      if (!reg.test(e.target.value)) {
        this.category.otherNumber = ""
        this.$message.error('请输入正确的分类编号（只能是数字）')
      } else {
        this.category.otherNumber = Number(e.target.value)
      }
    },
    retailPriceBlur(e) {
      for (var i = 0; i < this.tableData2.length; i++) {
        if (this.tableData2[i].barCode == e.target.dataset.index) {
          this.tableData2[i].retailPrice = Number(e.target.value).toFixed(2)
        }
      }
    },
    costPriceBlur(e) {
      for (var i = 0; i < this.tableData2.length; i++) {
        if (this.tableData2[i].barCode == e.target.dataset.index) {
          if (this.tableData2[i].costPrice == 0) {
            this.tableData2[i].costPrice = ''
          } else {
            this.tableData2[i].costPrice = Number(e.target.value).toFixed(2)
          }
        }
      }
    },
    memberPriceBlur(e) {
      for (var i = 0; i < this.tableData2.length; i++) {
        if (this.tableData2[i].barCode == e.target.dataset.index) {
          this.tableData2[i].memberPrice = Math.round(Number(e.target.value) * 100) / 100
          if (this.tableData2[i].memberPrice == 0) {
            this.tableData2[i].memberPrice = ""
          }
        }
      }
    },
    takePriceBlur(e) {
      for (var i = 0; i < this.tableData2.length; i++) {
        if (this.tableData2[i].barCode == e.target.dataset.index) {
          this.tableData2[i].takePrice = Number(e.target.value).toFixed(2)
          if (this.tableData2[i].takePrice == 0) {
            this.tableData2[i].takePrice = ""
          }
        }
      }
    },
    qrcStockCountBlur(e) {
      if (e.target.value < 0) {
        // this.qrcStockCount = ""
        this.$message.warning("库存不能为0")
        for (var i in this.tableData2) {
          this.tableData2[i].qrcStockCount = ""
        }
        return
      }
      this.qrcStockCount = e.target.value
      for (var i = 0; i < this.tableData2.length; i++) {
        if (this.tableData2[i].barCode == e.target.dataset.index) {
          this.tableData2[i].qrcStockCount = Number(e.target.value).toFixed(3)
        }
      }
    },
    jumpTT(adress){
      this.$router.push({path:adress})
    },
    //单位列表
    PortGoodsUnitList() {
      goodsUnitList({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        // pageNo: this.pageNum // 当前页码
        row: 9999, // 每页记录数
        isEnable: 1
      }).then(res => {
        console.log(res.data, "单位列表");
        if (res.code == 1) {
          this.unitList = res.data;
          for (var i in this.unitList) {
            if (this.unitList[i].unitType == 1) {
              this.unitList[i].goodsUnit = this.unitList[i].goodsUnit + " " + "(计数）"
            } else if (this.unitList[i].unitType == 2) {
              this.unitList[i].goodsUnit = this.unitList[i].goodsUnit + " " + "(计重）"
            }
          }
        } else {
          // this.$message.error(res.msg);
        }
      });
    },
    jumpUnit() {
      this.$router.push("/unitManagement");
    },
    changeCommidityPageNo() {
      console.log(this.commidityPageNo, "this.commidityPageNo");
      this.commidityPageNo = 2;
      console.log(this.commidityPageNo, "this.commidityPageNo");
    },
    //商品管理上传图片
    editHandleAvatarSuccess2(res) {
      let imgUploadForm = new FormData();
      imgUploadForm.append("file", res.file);
      imgUploadForm.append("fileContentType", res.file.type);
      imgUploadForm.append("fileFileName", res.file.name);
      imgUploadForm.append("isCompre", 1);
      imgUploadForm.append("isCutImage", 1);
      uploadImg(imgUploadForm)
        .then(res => {
          console.log(res);
          if (res.data.code == 1) {
            this.$message({
              message: res.data.msg,
              type: "success"
            });
            this.imageUrl = res.data.data.url;
            this.imageUrl2 = res.data.data.url;
          } else if (res.data.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(res => {});
    },
    //搜索商品回车
    searchEnter(res) {
      this.goodSearch = 1
      localStorage.setItem("searchContent", this.value2)
      var id = this.goodsCategoryId;
      if (id == undefined) {
        id = "";
      }
      res = res.replace(/(^\s+)|(\s+$)/g, "");
      this.$nextTick(()=> {
        this.Goods_goodsList(id, res, 10, 1); //商品列表
        this.pageNum = 1
        this.pageNos = 1
        // this.indexNumber = 0
      })
      console.log(id, res, "搜索");
    },
    searchContentBlur(e) {
      if (e.target.value.length == 0) {
        localStorage.removeItem("searchContent")
      }
    },
    //排序
    allSort() {
      var arr = this.commidityList;
      var jsonArr = [];
      for (let i in arr) {
        jsonArr.push({ goodsId: arr[i].id, indexNo: -i });
      }
      jsonArr = JSON.stringify(jsonArr);
      console.log(jsonArr, "排序后的新数组")
      // return
      this.request
        .post("qrcapi/Goods_batchUpdateGoods", {
          sessionId: this.userList.sessionId,
          userId: this.userList.id,
          goodsIndexNoJson: jsonArr,
          bachMethod: "I"
        })
        .then(res => {
          console.log(res);
          if (res.code == 1) {
            this.isSort = !this.isSort;
            this.$message({
              message: "保存成功",
              type: "success"
            });
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          alert("网络错误，不能访问");
          console.log(error);
        });
    },
    //批量上架
    allPutAway() {
      this.Goods_batchUpdateGoods("U", 1);
    },
    // 批量下架
    allSoldOut() {
      this.Goods_batchUpdateGoods("U", 0);
    },
    //上架
    allPutAway2(e) {
      console.log(e, "e");
      this.Goods_batchUpdateGoods2("U", 1, e.id);
    },
    // 下架
    allSoldOut2(e) {
      this.Goods_batchUpdateGoods2("U", 0, e.id);
    },
    //批量改分类
    allCateChange() {
      this.Goods_batchUpdateGoods("G", "", this.cateArr2);
      this.$refs["cateRadio2"].doClose();
    },
    //批量删除
    allRemove() {
      this.dialogVisible = false;
      this.Goods_batchUpdateGoods("D");
    },

    //  批量操作商品 排序、删除、上\下架、分组
    Goods_batchUpdateGoods2(bachMethod, saleStatus, goodIds) {
      var trueCommodity = this.trueCommodity;
      trueCommodity = trueCommodity.join(",");
      console.log(trueCommodity, bachMethod, "删除、上下架");
      this.request
        .post("qrcapi/Goods_batchUpdateGoods", {
          sessionId: this.userList.sessionId,
          userId: this.userList.id,
          goodIds: goodIds,
          saleStatus: saleStatus, //上下架   0 下架  1 上架
          bachMethod: bachMethod //// 处理方式 D 删除 U 上\下架  I 排序 G 分组
        })
        .then(res => {
          console.log(res);
          if (res.code == 1) {
            this.indexNumber = 0;
            console.log(bachMethod, "bachMethod111");
            if (bachMethod == "D" || bachMethod == "G") {
              this.goodsCategoryId = "";
            }
            this.Goods_goodsList(); // //获取商品列表
            this.$message({
              message: res.msg,
              type: "success"
            });
            this.trueCommodity = [];
            this.buttonState = 1;
            this.pageNum = 1;
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          alert("网络错误，不能访问");
          console.log(error);
        });
    },
    //  批量操作商品 排序、删除、上\下架、分组
    Goods_batchUpdateGoods(bachMethod, saleStatus, goodsCategoryId) {
      var trueCommodity = this.trueCommodity;
      trueCommodity = trueCommodity.join(",");
      console.log(trueCommodity, bachMethod, "删除、上下架");
      this.request
        .post("qrcapi/Goods_batchUpdateGoods", {
          sessionId: this.userList.sessionId,
          userId: this.userList.id,
          goodIds: trueCommodity,
          saleStatus: saleStatus, //上下架   0 下架  1 上架
          bachMethod: bachMethod, //// 处理方式 D 删除 U 上\下架  I 排序 G 分组
          goodsCategoryId: goodsCategoryId // 分组所需的分类id
          //  String goodsCategoryIndexNoJson; // 商品分类id 与排序值的组合 [{goodsCategoryId:1,indexNo:1},{...}]
        })
        .then(res => {
          console.log(res);
          if (res.code == 1) {
            this.indexNumber = 0; //左侧标签栏
            console.log(bachMethod, "bachMethod111");
            if (bachMethod == "D" || bachMethod == "G") {
              this.goodsCategoryId = "";
            }
            this.pageNum = 1;
            this.Goods_goodsList(); // //获取商品列表
            this.$message({
              message: res.msg,
              type: "success"
            });
            this.trueCommodity = [];
            this.buttonState = 1;
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          alert("网络错误，不能访问");
          console.log(error);
        });
    },
    expireTime_change(date) {
      console.log(date)
      this.ruleForm.expireTime = date
    },
    //提交添加商品表单
    submitForm() {
      console.log(111)
      // return
      console.log(this.ruleForm, "this.ruleForm.");
      var ruleForm = this.ruleForm;
      var saleStatus = Number(ruleForm.saleStatus);
      var isInfiniteStock = ruleForm.isInfiniteStock;
      var tableData2 = this.tableData2;
      var tableRule = tableData2[0];
      // if (this.unitTypes == 1) {
      //   let reg = /^[1-9]\d*$/
      //   if (!reg.test(this.qrcStockCount)) {
      //     this.$message.error("计件商品库存不能为小数哦~");
      //     return;
      //   }
      // }
      console.log(tableData2, "tableData2");
      if (tableData2.length > 0) {
        if (tableRule.specificationName == "" ) {
          this.$message.error("商品名称或者商品规格不能为空~");
          return;
        } else if (tableRule.retailPrice == "" ) {
          this.$message.error("请填写商品零售价");
          return;
        } else if (tableRule.barCode == "" ) {
          this.$message.error("请填写商品条码");
          return;
        } else if (tableRule.goodsUnitId == "" ) {
          this.$message.error("请选择商品单位");
          return;
        } else if (Number(tableRule.retailPrice) < Number(tableRule.memberPrice)) {
          this.$message.error("会员价不能高于零售价哦");
          return;
        }
        // if (
        //   tableRule.specificationName == "" ||
        //   tableRule.retailPrice == "" ||
        //   // tableRule.costPrice == "" ||
        //   // tableRule.memberPrice == "" ||
        //   tableRule.barCode == ""||
        //   tableRule.goodsUnitId== null
        //   // tableRule.takePrice==null
        // ) {
        //   this.$message.error("请完善商品规格");
        //   return;
        // }
      } else {
        // this.$message.error("请完善商品规格");
        if (tableRule.specificationName == "" ) {
          this.$message.error("商品名称或者商品规格不能为空~");
          return;
        } else if (tableRule.retailPrice == "" ) {
          this.$message.error("请填写商品零售价");
          return;
        } else if (tableRule.barCode == "" ) {
          this.$message.error("请填写商品条码");
          return;
        } else if (tableRule.goodsUnitId == "" ) {
          this.$message.error("请选择商品单位");
          return;
        } else if (Number(tableRule.retailPrice) < Number(tableRule.memberPrice)) {
          this.$message.error("会员价不能高于零售价哦");
          return;
        }
      }
      console.log("products")
      var products = [];
      for (let i in tableData2) {
        var isInfiniteStock2 = tableData2[i].isInfiniteStock;
        console.log(isInfiniteStock2, "isInfiniteStock2");
        if (isInfiniteStock2 == "无限库存") {
          isInfiniteStock2 = 1;
        } else if (isInfiniteStock2 == "自定义库存") {
          isInfiniteStock2 = 0;
        } else {
          console.log("isInfiniteStock2有误");
        }
        if (!tableData2[i].productId) {
          tableData2[i].productId = "";
        }
        products.push({
          productId: tableData2[i].productId,
          valueContent: tableData2[i].specificationName,
          retailPrice: tableData2[i].retailPrice,
          costPrice: tableData2[i].costPrice,
          memberPrice: tableData2[i].memberPrice,
          qrcStockCount: tableData2[i].qrcStockCount,
          barCode: tableData2[i].barCode,
          takePrice: tableData2[i].takePrice,
          goodsUnitId: tableData2[i].goodsUnitId,
          isInfiniteStock: isInfiniteStock2,
          expireTime: tableData2[i].expireTime
        });
      }

      products = JSON.stringify(products);
      console.log(products, "products");
      if (isInfiniteStock == "无限库存") {
        isInfiniteStock = 1;
      } else if (isInfiniteStock == "自定义库存") {
        isInfiniteStock = 0;
      } else {
        console.log("isInfiniteStock有误");
      }
      this.$refs["ruleForm"].validate(valid => {
        console.log(valid, "valid");
        if (valid) {
          this.Goods_createOrUpdateGoods(
            saleStatus,
            "",
            ruleForm.goodsName,
            ruleForm.goodsDescription,
            ruleForm.goodsBarCode,
            ruleForm.goodsCategoryId,
            products,
            ruleForm.retailPrice,
            ruleForm.costPrice,
            ruleForm.memberPrice,
            isInfiniteStock,
            ruleForm.qrcTotalStockCount,
            ruleForm.goodsRemark,
            ruleForm.expireTime
            // products.length
          );
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 添加\更新商品
    Goods_createOrUpdateGoods(
      saleStatus,
      goodsImage,
      goodsName,
      goodsDescription,
      goodsBarCode,
      goodsCategoryId,
      products,
      retailPrice,
      costPrice,
      memberPrice,
      isInfiniteStock,
      qrcTotalStockCount,
      goodsRemark
    ) {
      console.log(
        saleStatus,
        goodsImage,
        goodsName,
        goodsDescription,
        goodsCategoryId,
        products,
        retailPrice,
        costPrice,
        memberPrice,
        isInfiniteStock,
        qrcTotalStockCount,
        goodsRemark,
        // productCount,
        this.editGoodsId,
        "传过来的数据！！"
      );
      this.request
        .post("qrcapi/Goods_createOrUpdateGoods", {
          sessionId: this.userList.sessionId,
          userId: this.userList.id,
          saleStatus: saleStatus, //-1,-2,-3 (判断小于 0的) 强制下架  （根据情况设置的强制强度）   0：下架  1：上架
          goodsImage: this.imageUrl2, //blue
          goodsId: this.editGoodsId, // 有则更新 没有则添加
          goodsName: goodsName, //Goods_Name
          goodsDescription: goodsDescription, //商品详细
          goodsBarCode: goodsBarCode, //条码 --前面一段  可空。
          goodsCategoryId: goodsCategoryId, //产品分类 main
          //  productCount:productCount, //货品的数量 ： 0无货品  大于0 有货品 -读取 规格属性  没规格传0
          products: products, //规格
          // retailPrice: retailPrice, //销售价格
          // costPrice: costPrice, //货品的价格.
          isInfiniteStock: isInfiniteStock, //是否无限库存 1.无限  0.有限 设置库存数值
          qrcTotalStockCount: qrcTotalStockCount, //总库存 1-1000000  10000000  如果有规格，总量由product 统计
          goodsRemark: goodsRemark //备注
          // takePrice: "99", //拿货价 [可选]
          // costPrice: 111, //吊牌价  市场价
          // isPosChangePrice: "1", //收银时可否改价
          // //1.优惠问题 部分商品不想收银时改价
          // //2.部分商品 销售时无需 管理库存
        })
        .then(res => {
          if (res.code == 1) {
            console.log(res);
            this.Goods_goodsList();
            this.$message({
              message: "商品上传成功",
              type: "success"
            });
            this.ruleForm = {
              saleStatus: true,
              goodsName: "",
              goodsDescription: "",
              goodsCategoryId: "",
              products: [],
              retailPrice: "",
              costPrice: "",
              memberPrice: "",
              isInfiniteStock: "无限库存",
              qrcTotalStockCount: "",
              goodsRemark: ""
            };
            this.isAdd = !this.isAdd;
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          alert("网络错误，不能访问");
          console.log(error);
        });
    },
    //移动分类
    moveClassify(item) {
      console.log(item.goodsCategoryId);
      this.request
        .post("qrcapi/GoodsCategory_modifyGoodsCategoryIndex", {
          sessionId: this.userList.sessionId,
          userId: this.userList.id,
          goodsCategoryId: item.goodsCategoryId,
          modifyIndexType: 1
        })
        .then(res => {
          if (res.code == 1) {
            console.log(res);
            this.goodsCategoryList(this.classifyPage, 10); //获取分类
            this.$message({
              message: res.msg,
              type: "success"
            });
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          alert("网络错误，不能访问");
          console.log(error);
        });
    },
    //移动商品
    moveGoods(e) {
      console.log(e.id, "goodsId");
      this.request
        .post("qrcapi/Goods_modifyGoodsIndex", {
          sessionId: this.userList.sessionId,
          userId: this.userList.id,
          goodsId: e.id,
          modifyIndexType: 1
        })
        .then(res => {
          if (res.code == 1) {
            console.log(res);
            this.pageNum = 1;
            this.Goods_goodsList(this.goodsCategoryId);
            this.$message({
              message: "置顶成功",
              type: "success"
            });
            this.indexNumber = 0; //左侧标签栏
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            // this.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          alert("网络错误，不能访问");
          console.log(error);
        });
    },
    //删除商品
    removeGoods(e) {
      this.dialogVisible2 = false;
      this.request
        .post("qrcapi/Goods_removeGoods", {
          sessionId: this.userList.sessionId,
          userId: this.userList.id,
          goodsId: this.delGoodsId
        })
        .then(res => {
          if (res.code == 1) {
            console.log(res);
            this.goodsCategoryId = "";
            this.Goods_goodsList();
            this.$message({
              message: res.msg,
              type: "success"
            });
            this.indexNumber = 0; //左侧标签栏
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            // this.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          alert("网络错误，不能访问");
          console.log(error);
        });
    },

    //点击左侧tab栏
    navIndex(e) {
      this.expireTimeId = 99
      localStorage.removeItem("searchContent")
      this.value2 = ""
      this.buttonState = 1;
      this.indexNumber = e;
      console.log(e, "navIndex");
      if (e == 0) {
        this.goodsCategoryId = "";
        this.pageNum = 1;
        this.Goods_goodsList(this.goodsCategoryId);
      } else {
        this.goodsCategoryId = this.tableData[e].goodsCategoryId;
        this.pageNum = 1;
        this.Goods_goodsList(this.goodsCategoryId);
      }
    },
    //商品列表
    Goods_goodsList(goodsCategoryId, goodsName, pageSize, pageNumber, isExpire) {
      if (pageSize) {
      } else {
        pageSize = 10;
      }
      if (pageNumber) {
      } else {
        pageNumber = this.pageNum;
      }
      //  商品列表(分页)
      this.request
        .post("qrcapi/Goods_goodsPager", {
          sessionId: this.userList.sessionId,
          userId: this.userList.id,
          shopId: this.shopInformation.shopId, //商店id
          goodsCategoryId: goodsCategoryId, //分类id
          goodsName: goodsName, //商品名字
          // saleStatus:'', //-1,-2 强制下架   0：下架  1：上架
          pageNumber: pageNumber, // 当前页码
          pageSize: pageSize, // 每页记录数
          expireTime: isExpire
        })
        .then(res => {
          console.log(this.goodsCategoryId, "this.goodsCategoryId");
          console.log(res.data.pager, "获取商品列表");
          if (res.code == 1) {
            // this.$message({
            //   message: res.msg,
            //   type: "success"
            // });
            for (let i in res.data.pager.list) {
              this.$set(res.data.pager.list[i], "click", false);
            }

            if (res.data.pager.list.length == 0) {
              this.buttonState = 1;
            }
            
            this.commidityList = res.data.pager.list;
            // console.log(this.commidityList,'commidityList')
            this.totalCount = res.data.pager.totalCount;
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.commidityList = "";
            // this.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          alert("商品接口网络错误，不能访问");
          console.log(error);
        });
    },

    //分类列表
    goodsCategoryList(pageNo, pageSize) {
      goodsCategoryPager({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        pageNumber: pageNo,
        pageSize: pageSize
      })
        .then(res => {
          console.log(res.data, "分类列表");
          if (res.code == 1) {
            // this.$message({
            //   message: res.msg,
            //   type: "success"
            // });
            var num = 0;
            this.tableData = [{ categoryName: "全部", goodsTypes: "" }];
            for (let i in res.data.pager.list) {
              this.tableData.push(res.data.pager.list[i]);
              num += res.data.pager.list[i].goodsTypes;
            }
            this.totalCount2 = res.data.pager.totalCount;
            this.tableData[0].goodsTypes = num;
            this.goodsCategoryId = "";
            console.log(this.tableData, "tableData");
          } else {
            // this.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          alert("网络错误，不能访问");
          console.log(error);
        });
    },
    //全选状态
    commidityClick(item) {
      var trueNum = 0;
      var falseNum = 0;
      var arr = this.commidityList;
      var trueCommodity = this.trueCommodity; //勾选数组
      for (let i in arr) {
        if (arr[i].click) {
          trueNum++;
        } else {
          falseNum++;
        }
      }
      if (trueNum == 0) {
        this.buttonState = 1;
      } else if (falseNum == 0) {
        this.buttonState = 3;
      } else {
        this.buttonState = 2;
      }
      console.log(item.id, item.click);
      var indexOf = trueCommodity.indexOf(item.id);
      console.log(indexOf, "indexOf");
      if (indexOf == -1) {
        trueCommodity.push(item.id);
      } else {
        trueCommodity.splice(indexOf, 1);
      }
      console.log(trueCommodity, "trueCommodity");
    },
    handleReset(item) {
      console.log(item, "item111")
      this.radio = item.categoryName
    },
    //关闭分类
    cateOut(e) {
      // console.log(e)
      this.$refs["cateRadio"][e].doClose();
      // console.log(this.$refs['cateRadio'][0].doClose())
    },
    //关闭分类
    cateOut2(e) {
      // console.log(e)
      this.$refs["cateRadio2"].doClose();
      // console.log(this.$refs['cateRadio'][0].doClose())
    },
    //  Excel导入商品
    Goods_importGoodsNum(file) {
      this.request
        .post("qrcapi/Goods_importGoodsCategory", {
          sessionId: this.userList.sessionId,
          userId: this.userList.id,
          file: file
        })
        .then(res => {
          console.log(res, "导入商品");
          if (res.code == 1) {
            this.$message({
              message: res.msg,
              type: "success"
            });
            this.trueCommodity = [];
            this.buttonState = 1;
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          alert("网络错误，不能访问");
          console.log(error);
        });
    },
    handleErrorTable() {
      window.location.href = this.failGoodsExcelUrl
      this.dialogVisible6 = false
      this.Goods_goodsList()  
      this.indexNumber = 0
    },
    // 批量上传商品
    handleAvatarSuccess2(res) {
      // this.dialogVisible6 = true
      console.log(res.file);
      var sessionId = this.userList.sessionId;
      var userId = this.userList.id;
      let imgUploadForm = new FormData();
      imgUploadForm.append("file", res.file);
      // imgUploadForm.append("fileContentType", res.file.type);
      // imgUploadForm.append("fileFileName", res.file.name);
      imgUploadForm.append("userId", userId);
      imgUploadForm.append("sessionId", sessionId);
      console.log(imgUploadForm, "1");
      // this.Goods_importGoodsNum(imgUploadForm)
      uploadExcl(imgUploadForm)
        .then(res => {
          console.log(res);
          if (res.data.code == 1) {
            this.$message({
              message: res.data.msg,
              type: "success"
            });
            if (res.data.data.failGoodsList !== {}) {
              this.errorTableData = res.data.data.failGoodsList
              this.failCount = res.data.data.failCount
              this.successCount = res.data.data.successCount
              this.failGoodsExcelUrl = res.data.data.failGoodsExcelUrl
              this.dialogVisible6 = true
            } 
            // this.Goods_goodsList();
            // this.indexNumber = 0;
          } else if (res.data.code == 2) {
            this.$message.error(res.data.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(res => {
          console.log("error");
        });
    },
    handleAvatarSuccess3(res) {
      console.log(res.file);
      var sessionId = this.userList.sessionId;
      var userId = this.userList.id;
      let imgUploadForm = new FormData();
      imgUploadForm.append("file", res.file);
      // imgUploadForm.append("fileContentType", res.file.type);
      // imgUploadForm.append("fileFileName", res.file.name);
      imgUploadForm.append("userId", userId);
      imgUploadForm.append("sessionId", sessionId);
      console.log(imgUploadForm, "1");
      // this.Goods_importGoodsNum(imgUploadForm)

      uploadExcl2(imgUploadForm)
        .then(res => {
          console.log(res);
          if (res.data.code == 1) {
            this.$message({
              message: res.data.msg,
              type: "success"
            });
            this.goodsCategoryList(1, 9999);
          } else if (res.data.code == 2) {
            this.$message.error(res.data.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(res => {
          console.log("error");
        });
    },
    //修改分类
    cateChange(e) {
      console.log(this.cateArr[0], this.cateArr[1], "修改分类", e);
      this.request
        .post("qrcapi/Goods_batchUpdateGoods", {
          sessionId: this.userList.sessionId,
          userId: this.userList.id,
          bachMethod: "G",
          goodIds: this.cateArr[0],
          goodsCategoryId: this.cateArr[1]
        })
        .then(res => {
          console.log(res);
          if (res.code == 1) {
            this.goodsCategoryId = "";

            this.Goods_goodsList(); // //获取商品列表
            this.indexNumber = 0; //左侧标签栏
            this.$message({
              message: res.msg,
              type: "success"
            });
            this.pageNum = 1;
            this.trueCommodity = [];
            this.buttonState = 1;
            this.$refs["cateRadio"][e].doClose();
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          alert("网络错误，不能访问");
          console.log(error);
        });
    },
    //全选分类选择状态
    allCateClick(item2) {
      console.log(item2, "全选分类选择状态");
      this.cateArr2 = item2.goodsCategoryId;
      // console.log(this.cateArr)
    },
    //分类选择状态
    cateClick(item, item2) {
      console.log(item, item2, "分类选择");
      this.cateArr = [item.id, item2.goodsCategoryId];
      // console.log(this.cateArr)
    },
    // 控制门店照片上传
    handleAvatarSuccess1(res, file) {
      //上传成功时
      this.imageUrl1 = URL.createObjectURL(file.raw);
      console.log(res, file);
    },
    beforeAvatarUpload(file) {
      // // 上传之前
      // const isJPG = file.type === "image/jpeg";
      // const isLt2M = file.size / 1024 / 1024 < 2;
      // if (!isJPG) {
      //   this.$message.error("上传头像图片只能是 JPG 格式!");
      // }
      // if (!isLt2M) {
      //   this.$message.error("上传头像图片大小不能超过 2MB!");
      // }
      // return isJPG && isLt2M;
    },
    //分页选择每页多少条
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    //分页当前页
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val;
      var searchContent = ""
      searchContent = localStorage.getItem("searchContent")
      localStorage.setItem("pageNo", val)
      if (this.goodSearch = 1) {
        this.Goods_goodsList(this.goodsCategoryId, searchContent, "", this.pageNum, this.select_isExpire);
      } else {
        this.Goods_goodsList(this.goodsCategoryId, "", "", this.pageNum, this.select_isExpire);
      }
      this.buttonState = 1;
    },
    handleCurrentChange2(val) {
      console.log(`当前页: ${val}`);
      this.classifyPage = val;
      this.goodsCategoryList(val, 10);
    },
    //表格操作编辑按钮
    handleEdit(index, row) {
      var that = this;
      console.log(this.categoryEdit);
      that.request
        .post("qrcapi/GoodsCategory_modifyGoodsCategory", {
          sessionId: this.userList.sessionId,
          userId: this.userList.id,
          goodsCategoryId: this.handleEditId,
          categoryName: this.categoryEdit.value,
          otherNumber: this.categoryEdit.otherNumber
        })
        .then(res => {
          if (res.code == 1) {
            this.categoryEdit = {
              value: "",
              otherNumber: ""
            };
            console.log(res, "GoodsCategory_createGoodsCategory");
            this.dialogVisible5 = false;
            this.$nextTick(()=> {
              this.goodsCategoryList(1, 10);
              this.pageNos = 1
            })
            that.$message({
              type: "success",
              message: res.msg
            });
          } else if (res.code == 0) {
            this.$message.error(res.msg);
          }
        });
    },
    //新建分类
    open() {
      var that = this;

      that.request
        .post("qrcapi/GoodsCategory_createGoodsCategory", {
          sessionId: this.userList.sessionId,
          userId: this.userList.id,
          categoryName: that.category.value,
          otherNumber: that.category.otherNumber
        })
        .then(res => {
          console.log(res, "GoodsCategory_createGoodsCategory");
          if (res.code == 1) {
            this.goodsCategoryList(1, 10);
            that.$message({
              type: "success",
              message: res.msg
            });
            this.dialogVisible4 = false;
            this.category = {}
          } else {
            that.$message({
              type: "error",
              message: res.msg
            });
          }
        });
    },
    //表格操作删除按钮
    handleDelete(index, row) {
      console.log(index, row);
      this.tableData2.splice(index, 1);
    },
    // 删除分类
    handleDelete2(index, row) {
      console.log(this.delFenleiId, "delFenleiId");
      this.dialogVisible3 = false;
      this.request
        .post("qrcapi/GoodsCategory_removeGoodsCategory", {
          sessionId: this.userList.sessionId,
          userId: this.userList.id,
          goodsCategoryId: this.delFenleiId
        })
        .then(res => {
          console.log(res);
          if (res.code == 1) {
            this.$message({
              message: res.msg,
              type: "success"
            });
            this.goodsCategoryList(1, 10); //获取分类
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          alert("网络错误，不能访问");
          console.log(error);
        });
    },
    //表格添加规格
    handPush() {
      // var id = Math.floor(Math.random() * 10000000000);
      this.tableData2.push({
        specificationName: "",
        retailPrice: "",
        costPrice: "",
        memberPrice: "",
        barCode: "",
        isInfiniteStock: "无限库存",
        qrcStockCount: 0,
        goodsUnitId: null,
        takePrice: null
      });
    },
    //全选按钮
    ischeck() {
      var arr = this.commidityList;
      var trueCommodity = this.trueCommodity;
      console.log(this.buttonState)
      if (arr.length == 0) {
        this.buttonState == 1
        return
      }
      if (this.buttonState == 3) {
        for (let i in arr) {
          arr[i].click = false;
          let indexof = trueCommodity.indexOf(arr[i].id);
          if (indexof !== -1) {
            trueCommodity.splice(indexof, 1);
          }
        }
        this.buttonState = 1;
      } else {
        for (let i in arr) {
          arr[i].click = true;
          let indexof = trueCommodity.indexOf(arr[i].id);
          console.log(indexof, "indexof");
          if (indexof == -1) {
            trueCommodity.push(arr[i].id);
          }
        }
        this.buttonState = 3;
      }
    },
    handleClick(tab, event) {
      // console.log(tab, event);
    },
    Sort(e) {
      this.expireTimeId = 99
      this.isSort = !this.isSort;
      if (e) {
        this.Goods_goodsList(this.goodsCategoryId, "", 999999, 1);
      } else {
        this.Goods_goodsList(this.goodsCategoryId);
      }
    },
    Sort2() {
      this.isSort2 = !this.isSort2;
    },
    open2() {
      this.isSort = !this.isSort;
      this.$message({
        message: "保存成功",
        type: "success"
      });
    },
    //商品详情
    add(item) {
      this.expireTimeId = 99
      this.PortGoodsUnitList();
      this.editGoodsId = "";
      this.imageUrl2 = "";
      this.imageUrl = "";
      if (item) {
        this.isAddGoods = false;
        var goodsDetail = [];
        this.request
          .post("qrcapi/Goods_singleGoods", {
            sessionId: this.userList.sessionId,
            userId: this.userList.id,
            goodsId: item.id
          })
          .then(res => {
            console.log(res.data.products, "goodsDetail");
            if (res.code == 1) {
              goodsDetail = res.data.products;
              var tableData2 = [];
              for (let i in goodsDetail) {
                var isInfiniteStock;
                var qrcStockCount;
                if (goodsDetail[i].isInfiniteStock == 0) {
                  isInfiniteStock = "自定义库存";
                  qrcStockCount = goodsDetail[i].qrcStockCount;
                } else {
                  isInfiniteStock = "无限库存";
                  qrcStockCount = "";
                }
                tableData2.push({
                  specificationName: goodsDetail[i].valueContent,
                  retailPrice: goodsDetail[i].retailPrice ? goodsDetail[i].retailPrice.toFixed(2) : '',
                  costPrice: goodsDetail[i].costPrice ? goodsDetail[i].costPrice.toFixed(2) : '',
                  memberPrice: goodsDetail[i].memberPrice ? goodsDetail[i].memberPrice.toFixed(2) : '',
                  barCode: goodsDetail[i].barCode,
                  productId: goodsDetail[i].productId,
                  goodsUnitId: goodsDetail[i].goodsUnitId,
                  takePrice: goodsDetail[i].takePrice ? goodsDetail[i].takePrice.toFixed(2) : '',
                  isInfiniteStock: isInfiniteStock,
                  qrcStockCount: qrcStockCount ? goodsDetail[i].qrcStockCount.toFixed(3) : '',
                  unitType: goodsDetail[i].unitType,
                  expireTime: goodsDetail[i].expireTime
                });
              }
              this.tableData2 = tableData2;
              console.log(this.tableData2, "this.tableData2");
              this.unitTypes = this.tableData2[0].unitType
              // this.$message({
              //   message: res.msg,
              //   type: "success"
              // });
            } else if (res.code == 2) {
              this.$message.error(res.msg);
              this.$router.push("/");
            } else {
              this.$message.error(res.msg);
            }
          })
          .catch(function(error) {
            alert("网络错误，不能访问");
            console.log(error);
          });

        this.editGoodsId = item.id;
        var isInfiniteStock;
        if (item.isInfiniteStock == 1) {
          isInfiniteStock = "无限库存";
          this.inputShow = "无限库存";
        } else {
          isInfiniteStock = "自定义库存";
          this.inputShow = "自定义库存";
        }
        var saleStatus;
        if (item.saleStatus == 1) {
          saleStatus = true;
        } else {
          saleStatus = false;
        }
        var costPrice;
        if (item.costPrice) {
          costPrice = Number(item.costPrice);
        } else {
          costPrice = "";
        }
        var memberPrice;
        if (item.memberPrice) {
          memberPrice = Number(item.memberPrice)
        } else {
          memberPrice = ""
        }
        this.ruleForm = {
          saleStatus: saleStatus,
          goodsName: item.goodsName,
          goodsDescription: item.goodsDescription,
          goodsBarCode: item.goodsBarCode,
          goodsCategoryId: item.goodsCategoryId,
          products: item.products,
          retailPrice: Number(item.retailPrice),
          costPrice: costPrice,
          memberPrice: memberPrice,
          isInfiniteStock: isInfiniteStock,
          qrcTotalStockCount: item.qrcTotalStockCount,
          goodsRemark: item.goodsRemark
        };
        console.log(this.ruleForm, "this.ruleForm");
        this.imageUrl = item.goodsImage;
        this.imageUrl2 = item.goodsImage;
      } else {
        this.isAddGoods = true;
        this.ruleForm = {
          saleStatus: true,
          goodsName: "",
          goodsDescription: "",
          goodsCategoryId: "",
          products: [],
          retailPrice: "",
          costPrice: "",
          memberPrice: "",
          isInfiniteStock: "无限库存",
          qrcTotalStockCount: "",
          goodsRemark: ""
        };
        this.tableData2 =[
        {
          specificationName: "",
          retailPrice: "",
          costPrice: "",
          memberPrice: "",
          barCode: "",
          isInfiniteStock: "无限库存",
          qrcStockCount: 0,
          goodsUnitId: null,
          takePrice: null
        }
      ]
      }
      let pageNo = ""
      pageNo = localStorage.getItem("pageNo")
      this.indexNumber = 0; //左侧标签栏
      this.isAdd = !this.isAdd;
      console.log(this.editGoodsId, "111");
      // this.pageNum = 1
      this.Goods_goodsList("", "", "", pageNo); //刷新商品列表   
    },

    Show() {
      this.isShow = !this.isShow;
    },
    isinputShow(e) {
      this.inputShow = e;
    },
    //分类管理标签
    flTab(tab, event) {
      this.isAdd = false;
      // console.log( tab.label,event,"tabs");
      // if (this.activeName == "first") {
      //   this.goodsCategoryList(1, 10);
      // } else {
      //   this.goodsCategoryList(1, 10);
      // }

      if (tab.label == "商品管理") {
        this.goodsCategoryList(1, 9999);
      } else if (tab.label == "分类管理") {
        this.goodsCategoryList(1, 10);
      }

      if (tab.label == "单位管理") {
        this.jumpUnit();
      }
    }
  }
};
</script>

<style scoped>
.commodityHead {
  box-sizing: border-box;
  width: 100%;
  padding: 15px 20px 15px 30px;
  background: #f8f8f8;
  height: 60px;
  position: fixed;
  top: 39px;

  z-index: 100;
  border-top: 1px solid #eeeeee;
  border-bottom: 1px solid #eeeeee;
}
.commodityHead3 {
  /* width: 1235px; */
  width: 1215px;
  padding: 26px 20px;
  background: #f8f8f8;
  border-radius: 4px;
  margin-top: 20px;
  font-size: 12px;
}
.loadup {
  padding: 0 10px;
  height: 30px;
}
.button {
  width: 70px;
  height: 30px;
  padding: 0;
}
.button2 {
  width: 70px;
  height: 30px;
  padding: 0;
  color: #409eff;
  border: 1px solid #409eff;
  margin-left: 0px;
}
.text2 {
  color: #bbb;
  font-size: 14px;
}
.el-input__icon {
  line-height: 30px;
}

.el-input__inner {
  height: 30px;
}
.commidity {
  box-sizing: border-box;
  font-size: 16px;
  padding: 20px 20px 20px 20px;
}
.commidity2 {
  font-size: 16px;
  padding: 20px 45px 20px 20px;
  margin-top: 60px;
}
.commidityItemImg img {
  height: 50px;
  width: 50px;
}
.commidityItemImg2 img {
  height: 50px;
  width: 50px;
}
.commidityItemImg {
  position: relative;
  height: 50px;
  width: 50px;
}
.commidityItemImg::before {
  content: "\5DF2\4E0B\67B6";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  text-align: center;

  line-height: 50px;
  font-size: 12px;
}
.commidityItem {
  padding-bottom: 16px;
  border-bottom: 1px solid #eee;
}
.commidityItem:not(:first-child) {
  margin-top: 16px;
}
.red {
  color: red;
  font-size: 13px;
}
.num {
  color: #bbb;
  margin-left: 10px;
  font-size: 12px;
}
.member-price {
  color: #666;
  margin-left: 10px;
  font-size: 12px;
}
.classfiyPop {
  margin-top: 10px;
}
.br {
  height: 1px;
  background: #eee;
  margin: 10px 0;
}
.button3 {
  height: 28px;
  width: 38px;
}
.commodityHead2 {
  width: 100%;
  background: #fffae4;
  padding: 15px 30px;
  position: fixed;
  top: 39px;
  z-index: 100;
}
.from {
  box-sizing: border-box;
  width: 100%;
  padding: 35px 0 0 50px;
  overflow-y: scroll;
  /* height: 910px; */
}
.leftTabs {
  margin-top: 59px;
  height: 100%;
  height: calc(100% - 59px);
}
.nav {
  background: #f8f8f8;
  width: 120px;
  height: calc(100vh - 100px);
  border-right: 1px solid #eeeeee;
  position: fixed;
  overflow-y: scroll;
}
.nav-hiddenScroll {
  background: #f8f8f8;
  width: 120px;
  height: calc(100vh - 100px);
  border-right: 1px solid #eeeeee;
  position: fixed;
  overflow-y: scroll;
}
.nav::-webkit-scrollbar {
  display: none;
}
.navBlock {
  /* height: 50px; */
  box-sizing: border-box;
  padding: 20px 30px;
  font-size: 12px;
  cursor: pointer;
  border-bottom: 1px solid #eeeeee;
}
.navBlock_click {
  background: #fff;
  /* height: 50px; */
  box-sizing: border-box;
  /* padding-top: 20px;
  padding-left: 30px; */
  padding: 20px 30px;
  font-size: 12px;
  cursor: pointer;
  border-bottom: 1px solid #eeeeee;
}
.commiditynavContent {
  /* margin-left: 120px; */
  box-sizing: border-box;
  padding: 0 20px;
  width: 100%;
  margin-top: 20px;
}
.navContent {
  width: 100%;
  margin-left: 121px;
}
.display {
  display: none;
}
.goodName {
  width: 200px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
<style>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type='number'] {
  -moz-appearance: textfield;
}
.el-table td, .el-table th {
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/page/commodity.vue